export default __webpack_public_path__ + "static/media/logo_parceiros.58908cec.svg";